import React from 'react';
import { withNamespaces } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import PayrollFileConfigurationAPI from '../../api/payroll-file-configurations';
import DefaultPayrollFileForm from '../../components/DefaultPayrollFileForm';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import SpaceSpinner from '../../components/SpaceSpinner';
import Toast from '../../components/Toast';
import PageContainer from '../../containers/PageContainer';
import { INTERNAL_LINKS } from '../../enum';
import withAuthentication from '../../hocs/withAuthentication';

const UpdateCustomPayrollFileView = props => {
  const { t, history, match } = props;

  const queryClient = useQueryClient();

  const payrollFileConfigurationDetailsQuery = useQuery({
    queryKey: ['fetchPayrollFileConfigurationDetails', match.params.id],
    queryFn: () =>
      new PayrollFileConfigurationAPI().fetchPayrollFileConfigurationDetails(match.params.id),
  });

  const updatePayrollFileConfigurationMutation = useMutation(
    data =>
      new PayrollFileConfigurationAPI().updatePayrollFileConfiguration(match.params.id, {
        ...data,
        companyId: match.params.companyId,
        isGlobal: false,
      }),
    {
      onSuccess: responseData => {
        queryClient.invalidateQueries(['fetchPayrollFileConfiguration', match.params.companyId]);
        queryClient.setQueryData(
          ['fetchPayrollFileConfigurationDetails', match.params.id],
          responseData,
        );
        Toast({
          type: 'success',
          message: t('updatePayrollFileConfigurationSuccess'),
        });
      },
      onError: () => {
        Toast({
          type: 'error',
          message: t('updatePayrollFileConfigurationError'),
        });
      },
    },
  );

  const handleSubmit = payload => {
    updatePayrollFileConfigurationMutation.mutate(payload);
  };

  if (payrollFileConfigurationDetailsQuery.isFetching) {
    return <SpaceSpinner />;
  }

  return (
    <PageContainer
      title={
        <PageBreadcrumbs
          items={[
            {
              label: t('Company'),
              onClick: () =>
                history.push(
                  `${INTERNAL_LINKS.SELECT_COMPANY}/${match.params.companyId}?activeTab=payrollFileConfiguration`,
                ),
            },
            { label: t('payrollFileConfiguration') },
          ]}
        />
      }
    >
      <DefaultPayrollFileForm
        t={t}
        isUpdate
        onSubmit={handleSubmit}
        disabled={updatePayrollFileConfigurationMutation.isLoading}
        loading={updatePayrollFileConfigurationMutation.isLoading}
        initialData={payrollFileConfigurationDetailsQuery.data}
      />
    </PageContainer>
  );
};

export default withNamespaces()(withAuthentication(UpdateCustomPayrollFileView));
